import { useAuthenticationContext } from "@/contexts/authentication/authentication.context";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/system-settings")({
  component: SystemSettingsRedirect,
});

function SystemSettingsRedirect() {
  const { uid } = useAuthenticationContext();
  return uid ? (
    <Navigate
      to="/user/$userId/account-settings"
      params={{ userId: uid }}
      replace
    />
  ) : null;
}
